export default __webpack_public_path__ + "static/media/52.6da293e3.gif";